/**
 * Available categories
 */
export enum GameCategory {
  OKTOBER_FEST = 121,
  SLOTS = 48,
  BLACKJACK = 50,
  ROULETTE = 49,
  VIDEO_POKER = 63,
  TABLE_GAMES = 64,
  BONUS_BUY = 80,
  LIVE_CASINO = 61,
  BACCARAT = 68,
  OTHER_GAMES = 69,
  FAST_PLAY = 85,
  FAVORITE = 'favorite',
  LAST_PLAYED = 'last-played',
  FAVORITE_ID = 67,
  LAST_PLAYED_ID = 65,
  FILTER = 'filter',
  FREE_SPINS_CATEGORY = 81,
  FREE_SPINS = 'free-spins',
  HALLOWEEN_GAMES = 103,
  HALLOWEEN_SLUG = 'halloween-games',
  TOP = 87,
  XMAS_GAMES = 84,
  SPINFINITY_QUEST = 101,
  SPINDER = 86,
  EASTER = 78,
  TROPICAL = 107,
  THANK_YOU = 109,
  JACKPOT = 98,
  BONANZA_JACKPOT = 115,
  BONANZA_JACKPOT_SLUG = 'bonanza-jackpot',
  PATRICK = 94,
  SUMMER = 138,
}
